export default __webpack_public_path__ + "static/media/avatar-s-20.40d668f5.jpg";